import Page, { PageRoute } from '../components/Page';
import useEntryTrack from '../hooks/useEntryTrack';
import { ReactComponent as PaySvg } from '../assets/pay.svg';
import Icon from '@ant-design/icons/lib/components/Icon';
import Csat from './Csat';
import { getRouteAccess } from '../Scenario/config';

export const csatRouteAccess = getRouteAccess('配置智能CSAT邀评');

export const route: PageRoute = {
  path: 'csat',
  i18nHelmetTitle: '智能CSAT邀评',
  menu: {
    label: '智能CSAT邀评',
    icon: <Icon component={PaySvg} />,
  },
  element: <CsatPage />,
  access: csatRouteAccess,
};

function CsatPage() {
  useEntryTrack('aide/csat');

  return (
    <Page
      route={{
        ...route,
        element: <Csat />,
      }}
    />
  );
}

export default CsatPage;
